Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionChartListItemView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/session_chart_list_item']
  tagName: 'li'
  className: 'chart-to-add'

  events:
    'click': 'addChart'

  initialize: (title, name, session) ->
    @title = title
    @name = name
    @session = session

  render: ->
    @$el.html @template
      title: @title
    @

  addChart: ->
    @session.addWidget({type: @name})
